import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { DeliveryAddressService } from '@checkout/feature';
import { ModalService } from '@spartacus/storefront';
import { Subscription, merge } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'sd-delivery-address-list-modal',
  templateUrl: './delivery-address-list-modal.component.html',
  styleUrls: ['./delivery-address-list-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorDeliveryAddressListModalComponent implements OnInit, OnDestroy {
  protected subscription = new Subscription();

  constructor(
    private deliveryAddressService: DeliveryAddressService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      merge(this.deliveryAddressService.selectActiveAddressIdEvent, this.deliveryAddressService.savedAddressEvent)
        .pipe(delay(50))
        .subscribe(() => {
          this.modalService.closeActiveModal();
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
